import SETTINGS from "../../settings";
import { getSolarData } from "../../utils/mapping-functions";

import log from "loglevel";

const SunPath = (props) => {
  log.info("Sun Path");
  const heightMap = props.heightMap;
  let annualDivisions = 12;
  let dailyDivisions = 120;
  let annualSolarData = [];
  for (let i = 0; i < annualDivisions; i++) {
    let date = Math.floor((365 * i) / 2 / annualDivisions);
    for (let j = 0; j < dailyDivisions; j++) {
      let time = (12 * j) / dailyDivisions + 6;
      annualSolarData.push(getSolarData(heightMap.boundBox.north, date, time));
    }
  }
  const scale = heightMap.boundBox.size.x / 1000;
  return (
    <>
      {annualSolarData.map((v, i) => {
        return (
          <line key={i}>
            <geometry
              attach="geometry"
              // position={[0, 1, 0]}
              vertices={[
                new THREE.Vector3(0, 0, 0),
                new THREE.Vector3(
                  (scale * v.position.x) / 2,
                  (scale * v.position.z) / 2,
                  (scale * v.position.y) / 2
                ),
              ]}
              onUpdate={(self) => (self.verticesNeedUpdate = true)}
            />
            <lineBasicMaterial
              attach="material"
              color={new THREE.Color(v.season, 0, 1 - v.season)}
            />
          </line>
        );
      })}
    </>
  );
};

export default React.memo(SunPath);
